import React from "react";
import "./FooterStyles.css";

export default function Footer() {
  return (
    <>
      <div>
        <div className="footer">Copyright © 2025-26 vizerto.com</div>
      </div>
    </>
  );
}
